// Security utility functions

/**
 * Validate and sanitize blog slug parameter
 * @param slug - The slug from URL parameters
 * @returns Sanitized slug or null if invalid
 */
export const validateBlogSlug = (slug: string | undefined): string | null => {
  if (!slug) return null;
  
  // Only allow alphanumeric characters, hyphens, and underscores
  const sanitizedSlug = slug.toLowerCase().trim();
  const slugRegex = /^[a-z0-9-_]{1,100}$/;
  
  if (!slugRegex.test(sanitizedSlug)) {
    console.warn('Invalid blog slug detected:', slug);
    return null;
  }
  
  return sanitizedSlug;
};

/**
 * Generate a unique nonce for inline scripts
 * @returns A base64 encoded nonce
 */
export const generateNonce = (): string => {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return btoa(String.fromCharCode(...array));
};

/**
 * Sanitize user input to prevent XSS
 * @param input - User input string
 * @returns Sanitized string
 */
export const sanitizeInput = (input: string): string => {
  return input
    .replace(/[<>]/g, '') // Remove angle brackets
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/on\w+\s*=/gi, '') // Remove event handlers
    .trim();
};

/**
 * Validate URL to ensure it's safe to use
 * @param url - URL to validate
 * @returns true if URL is safe, false otherwise
 */
export const isValidUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    // Only allow http and https protocols
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch {
    return false;
  }
};